var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is.loading)?_c('loader'):[_c('order-configuration',{attrs:{"configuration":_vm.entity.configuration,"order":_vm.entity}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }